import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function DistribucionAnexo21y22RMF2026SistemasDeMedicion() {
  return (
    <CategoryPage
      category="distribucionAnexo21Y22Rmf2026SistemasDeMedicion2026"
      pageTitle="Sistemas De Medicion 2026"
    />
  );
}

export default DistribucionAnexo21y22RMF2026SistemasDeMedicion;
